module.exports = __webpack_public_path__ + "static/img/wzry-coreTechnology1.032bec2f.png";